import { request, post } from '@/axios';

/**
 * @description: 获取sud游戏配置
 * @param
 * @return {*}
 */
export function getSudConfig() {
  return request({
    url: '/voiceRoom/sud/config',
    method: 'GET'
  });
}

/**
 * @description: 是否显示小游戏
 * @param
 * @return {*}
 */
export function getGameShow() {
  return request({
    url: '/voiceRoom/gameShow',
    method: 'GET'
  });
}

/**
 * @description: 獲取遊戲列表
 * @param
 * @return {*}
 */
export function getGameList(params) {
  return post('/voiceRoom/outside/list',params);
}

/**
 * @description: 创建/编辑游戏房
 * @param
 * @return {*}
 */
export function createOrUpdateRoom(params) {
  return post('/voiceRoom/createOrUpdate', params);
}

export function getCode(params) {
  return request({
    url: '/voiceRoom/sud/getCode',
    method: 'GET',
    params
  });
}